module.exports = __webpack_public_path__ + "static/img/timeQG.69f9eb77.jpg";